export const iconFontAwesomeHouseholdToiletPaper = (
	<i className="fa-solid fa-toilet-paper"></i>
);
